import ApplicationsApiService from './_services/applications.api.service';

import { ActionTypes, MutationTypes } from './store.type';

export { namespace } from './store.type';

export default {
  namespaced: true,
  state: {
    applications: [],
    applicationUsers: [],
    applicationHistory: [],
  },
  mutations: {
    [MutationTypes.SET_APPLICATIONS](state, payload) {
      state.applications = payload;
    },
    [MutationTypes.SET_APPLICATION_USERS](state, payload) {
      state.applicationUsers = payload;
    },
    [MutationTypes.SET_APPLICATION_HISTORY](state, payload) {
      state.applicationHistory = payload;
    },
  },
  actions: {
    async [ActionTypes.GET_APPLICATIONS]({ commit }, { pageNum, ...rest }) {
      commit(
        MutationTypes.SET_APPLICATIONS,
        await ApplicationsApiService.getApplications({ ...rest }),
      );
    },
    async [ActionTypes.GET_APPLICATION_HISTORY]({ commit }, { pageNum, ...rest }) {
      commit(
        MutationTypes.SET_APPLICATION_HISTORY,
        await ApplicationsApiService.getApplicationHistory({ pageNum, ...rest }),
      );
    },
    async [ActionTypes.GET_APPLICATION_USERS]({ commit }, { ...rest }) {
      commit(
        MutationTypes.SET_APPLICATION_USERS,
        await ApplicationsApiService.getApplicationUsers({ ...rest }),
      );
    },
  },
};
